import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logoBlanco from '../assets/logo_blanco.png';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <img
          src={logoBlanco}
          alt="Logo MBZ"
          className="footer-logo"
        />

        <div className="social-icons">
          <a
            href="https://www.instagram.com/centrombz"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-instagram"></i>
          </a>
          <a
            href="https://www.tiktok.com/@centrombz"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-tiktok"></i>
          </a>
          <a
            href="https://www.linkedin.com/company/centro-mbz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin"></i>
          </a>
          <a
            href="https://wa.me/34636720737"
            target="_blank"
            rel="noopener noreferrer"
            title="Escríbenos por WhatsApp"
          >
            <i className="fab fa-whatsapp"></i>
          </a>
        </div>

        <p>
          <a
            href="https://www.google.com/maps?q=Polígono+Arbide,+Calle+A,+2,+31110+Noáin,+Navarra"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Polígono Arbide, Calle A 2, 31110 Noáin (Navarra)
          </a>
        </p>

        <p>
          <a
            href="tel:34636720737"
            className="footer-link"
            title="Llamar a +34 636 72 07 37"
          >
            +34 636 72 07 37
          </a>
        </p>

        <p>
          <a
            href="mailto:info@centrombz.es"
            className="footer-link"
            title="Enviar correo a info@centrombz.es"
          >
            info@centrombz.es
          </a>
        </p>

        <p>
          <Link to="/politica-privacidad" className="footer-link">
            Política de privacidad
          </Link>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
